import { render, staticRenderFns } from "./ecologicalOrder.vue?vue&type=template&id=49668242&scoped=true"
import script from "./ecologicalOrder.vue?vue&type=script&lang=js"
export * from "./ecologicalOrder.vue?vue&type=script&lang=js"
import style0 from "./ecologicalOrder.vue?vue&type=style&index=0&id=49668242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49668242",
  null
  
)

export default component.exports